import { apiClient } from '../../axios';
import { GetChartDrawingsResponse } from './types';

export const getChartDrawingsApi = (id: string) =>
  apiClient.get<GetChartDrawingsResponse>(`/v1/chart/pattern/drawings/${id}`);
